var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contain",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H60a4,4,0,0,1,4,4V60a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4 3 C 3.448600769042969 3 3 3.448600769042969 3 4 L 3 60 C 3 60.55139923095703 3.448600769042969 61 4 61 L 60 61 C 60.55139923095703 61 61 60.55139923095703 61 60 L 61 4 C 61 3.448600769042969 60.55139923095703 3 60 3 L 4 3 M 4 0 L 60 0 C 62.20914459228516 0 64 1.790855407714844 64 4 L 64 60 C 64 62.20914459228516 62.20914459228516 64 60 64 L 4 64 C 1.790855407714844 64 0 62.20914459228516 0 60 L 0 4 C 0 1.790855407714844 1.790855407714844 0 4 0 Z",
    stroke: "none",
    fill: "#8898aa"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    transform: "translate(0 13)",
    fill: "#8898aa",
    stroke: "#fff",
    strokeWidth: 6,
    strokeDasharray: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 39,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 58,
    height: 33,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContain);
export default __webpack_public_path__ + "static/media/contain.f55aff33.svg";
export { ForwardRef as ReactComponent };